import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { CRUD } from '../interfaces/crud.interface';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { OffersMassEditionService } from '../services/offers-mass-edition.service';
import { LoggerService } from '../services/logger.service';

export class RESTDataSource<T> implements DataSource<T> {
  private dataSubject = new BehaviorSubject<T[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private countSubject = new BehaviorSubject<number>(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.countSubject.asObservable();

  constructor(private crud: CRUD<T>, private offersMassEditionService?: OffersMassEditionService) {}

  setDataSource(data): void {
    this.dataSubject.next(data);
  }

  getDataSource() {
    return this.dataSubject.getValue();
  }

  setCount(count: number): void {
    this.countSubject.next(count);
  }

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadData(query: any, pageIndex: number, pageSize: number, sortDirection: string) {
    LoggerService.log('RESTDataSource::loadData');
    this.loadingSubject.next(true);

    this.crud
      .findAll(query, pageIndex, pageSize)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data);
      });

    this.crud.count(query).subscribe(count => this.countSubject.next(count.matchingResults));
  }

  loadDataWithModifications(query: any, pageIndex: number, pageSize: number) {
    LoggerService.log('RESTDataSource::loadData');
    this.loadingSubject.next(true);

    this.crud
      .findAll(query, pageIndex, pageSize)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => this.modifyOffer(data));

    this.crud.count(query).subscribe(count => this.countSubject.next(count.matchingResults));
  }

  modifyOffer(offers: T[]): void {
    offers = this.offersMassEditionService.modifyOffers(offers);
    this.dataSubject.next(offers);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/rest.datasource.ts